import React, { useState } from "react";
import { useRouter } from "next/router";
import { useTranslations } from "next-intl";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import { Navigation } from "swiper";
import PrevArrow from "../../../assets/PrevArrow";
import NextArrow from "../../../assets/NextArrow";
import Image from "next/image";
import Section_name from "../../../ipillion/Section_name";
import Swift from "../../../../public/projects/Ezcredit/Swift";
import Sql from "../../../../public/projects/Ezcredit/Sql";
import Python from "../../ezcredit/icons/Python";
import Flutter from "../../../../public/ipillion/Flutter";
import Next from "../../../../public/ipillion/Next";
import Laravel from "../../../../public/ipillion/Laravel";
import Css from "../../../../public/ipillion/Css";
import Html from "../../../../public/ipillion/Html";
export default function TechSlider() {
  const router = useRouter();
  const lang = router.locale;
  const [arrow, setArrow] = useState({ isEnd: false, isBeginning: true });

  const t = useTranslations("ipillion.TechSlider");

  return (
    <div className="relative mb-5">
      <div className=" max-w-[90rem] responsive m-auto">
        <Section_name
          name={t("title")}
          color={"#D60014"}
          margin={"mt-[88px]"}
        />
      </div>

      {/* <div className=" max-w-[90rem] responsive flex items-center justify-center  relative  "> */}
      <div className="max-w-[90rem] responsive relative mx-auto">
        <Swiper
          key={router.locale + "TechSlider"}
          slidesPerView={1}
          spaceBetween={20}
          breakpoints={{
            633: { slidesPerView: 1.3, spaceBetween: 0 },
            949: { slidesPerView: 2.5, spaceBetween: 20 },
            1261: { slidesPerView: 3, spaceBetween: 20 },
            1450: { slidesPerView: 4, spaceBetween: 20 },
          }}
          onSwiper={(swiper) => (next = swiper)}
          onSlideChange={(swiper) =>
            setArrow({ isEnd: swiper.isEnd, isBeginning: swiper.isBeginning })
          }
          modules={[Navigation]}
          navigation={{
            nextEl: ".swiper-button-next-4",
            prevEl: ".swiper-button-prev-4",
          }}
          className="relative h-64 max-w-[90rem] responsive"
        >
          <SwiperSlide
            className={`${
              lang == "ar" ? "border-l-[2px]" : "border-r-[2px]"
            }  border-[#D9D9D9]  max-w-[420px] h-56 flex flex-col justify-between`}
          >
            <div className=" w-full ml-2 flex justify-between flex-col h-fit">
              <div className="h-[93px] w-[93px] bg-white flex items-center justify-center rounded-full mb-2 shadow-md">
                <Laravel />
              </div>
              <h3 className="text-[24px] font-[600] text-[#6D2E88] mb-3">
                {t("slides.laravel.name")}
              </h3>
              <div className="max-w-[270px]">
                <p className="lg:text-[24px] text-[16px] lg:leading-[26px] leading-[20px] font-[400]">
                  {t("slides.laravel.desc")}
                </p>
              </div>
            </div>
          </SwiperSlide>
          <SwiperSlide
            className={`${
              lang == "ar" ? "border-l-[2px]" : "border-r-[2px]"
            } border-[#D9D9D9]  max-w-[420px] h-56 flex flex-col justify-between`}
          >
            <div className=" w-full ml-2 flex justify-between  flex-col h-fit">
              <div className="h-[93px] w-[93px] bg-white flex items-center justify-center rounded-full mb-2 shadow-md">
                <Next />
              </div>
              <h3 className="text-[24px] font-[600] text-[#6D2E88] mb-3">
                {t("slides.nextjs.name")}
              </h3>
              <div className="max-w-[270px]">
                <p className="lg:text-[24px] text-[16px] lg:leading-[26px] leading-[20px] font-[400]">
                  {t("slides.nextjs.desc")}
                </p>
              </div>
            </div>
          </SwiperSlide>
          <SwiperSlide
            className={` ${
              lang == "ar" ? "border-l-[2px]" : "border-r-[2px]"
            } border-[#D9D9D9]  max-w-[420px] h-56 flex flex-col justify-between`}
          >
            <div className=" w-full ml-2 flex justify-between  flex-col h-fit">
              <div className="h-[93px] w-[93px] bg-white flex items-center justify-center rounded-full mb-2 shadow-md">
                <Css />
              </div>
              <h3 className="text-[24px] font-[600] text-[#6D2E88] mb-3">
                {t("slides.css.name")}
              </h3>
              <div className="max-w-[270px]">
                <p className="lg:text-[24px] text-[16px] lg:leading-[26px] leading-[20px] font-[400]">
                  {t("slides.css.desc")}
                </p>
              </div>
            </div>
          </SwiperSlide>
          <SwiperSlide
            className={`${
              lang == "ar" ? "border-l-[2px]" : "border-r-[2px]"
            } border-[#D9D9D9]  max-w-[420px] h-56 flex flex-col justify-between`}
          >
            <div className=" w-full ml-2 flex justify-between  flex-col h-fit">
              <div className="h-[93px] w-[93px] bg-white flex items-center justify-center rounded-full lg:mb-2 mb-1 shadow-md">
                <Html />
              </div>
              <h3 className="text-[24px] font-[600] text-[#6D2E88] lg:mb-3 mb-1">
                {t("slides.html.name")}
              </h3>
              <div className="max-w-[270px]">
                <p className="lg:text-[24px] text-[16px] lg:leading-[26px] leading-[20px] font-[400]">
                  {t("slides.html.desc")}
                </p>
              </div>
            </div>
          </SwiperSlide>
          <SwiperSlide
            className={` ${
              lang == "ar" ? "border-l-[2px]" : "border-r-[2px]"
            } border-[#D9D9D9]  max-w-[420px] h-56 flex flex-col justify-between`}
          >
            <div className=" w-full ml-2 flex justify-between  flex-col h-fit">
              <div className="h-[93px] w-[93px] bg-white flex items-center justify-center rounded-full mb-2 shadow-md relative">
                <Flutter />
              </div>
              <h3 className="lg:text-[24px] text-[18px] font-[600] text-[#6D2E88] lg:mb-3 mb-1">
                {t("slides.flutter.name")}
              </h3>
              <div className="max-w-[270px]">
                <p className="lg:text-[24px] text-[16px] lg:leading-[26px] leading-[20px] font-[400]">
                  {t("slides.flutter.desc")}
                </p>
              </div>
            </div>
          </SwiperSlide>
          <SwiperSlide
            className={` ${
              lang == "ar" ? "border-l-[2px]" : "border-r-[2px]"
            } border-[#D9D9D9]  max-w-[420px] h-56 flex flex-col justify-between`}
          >
            <div className=" w-full ml-2 flex justify-between  flex-col h-fit">
              <div className="h-[93px] w-[93px] bg-white flex items-center justify-center rounded-full mb-2 shadow-md">
                <Sql />
              </div>
              <h3 className="text-[24px] font-[600] text-[#6D2E88] mb-3">
                {t("slides.mysql.name")}
              </h3>
              <div className="max-w-[270px]">
                <p className="lg:text-[24px] text-[16px] lg:leading-[26px] leading-[20px] font-[400]">
                  {t("slides.mysql.desc")}
                </p>
              </div>
            </div>
          </SwiperSlide>
        </Swiper>
      </div>
      <div
        className={`flex justify-center -ml-20 -mr-10 ${
          lang == "ar" ? "-mr-20 -ml-10" : "-ml-20 -mr-10"
        }`}
      >
        <div className=" hidden px-[6%] w-full absolute z-50 top-[65%] lg:flex justify-between right-0">
          <button
            className={`swiper-button-prev-4 ${
              lang == "ar" ? "-scale-x-100" : null
            }`}
          >
            <PrevArrow arrow={arrow} />
          </button>
          <button
            className={`swiper-button-next-4 ${
              lang == "ar" ? "-scale-x-100" : null
            }`}
          >
            <NextArrow arrow={arrow} />
          </button>
        </div>
      </div>
    </div>
  );
}
